import { render, staticRenderFns } from "./deployMy.vue?vue&type=template&id=0f415f65&scoped=true&"
import script from "./deployMy.vue?vue&type=script&lang=js&"
export * from "./deployMy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f415f65",
  null
  
)

export default component.exports